<template>
    <section class="ui-dash-box-info" :style="bgCss">
        <div v-if="!load" class="icon">
            <i :class="icon" />
        </div>

        <div v-if="!load" class="infos">
            <div class="number">
                <span v-if="numberPrefix">{{numberPrefix}}</span>
                {{ number }}
                <small v-if="numberSufix">{{numberSufix}}</small>
            </div>

            <div class="text">{{ text }}</div>

            <div v-if="meta" class="text-sm">{{ meta }}</div>
        </div>
        <ui-overlay-load v-if="load" />
    </section>
</template>

<script>
    import { uiOverlayLoad } from '@/components/ui'

    export default {
         name: 'ui-dash-infos',

         components: { uiOverlayLoad },

         props: {
			   icon: {
               type: String,
               required: false,
               default: ''
            },
            number: {
               type: String,
               required: false,
               default: ''
            },
            text: {
               type: String,
               required: false,
               default: ''
            },
            meta: {
               type: String,
               required: false,
               default: ''
            },
            numberPrefix: {
               type: String,
               required: false,
               default: ''
            },
            numberSufix: {
               type: String,
               required: false,
               default: ''
            },
            color: {
               type: String,
               required: false,
               default: ''
            },
            load: {
               type: Boolean,
               required: false
            },
        },

        data() {
            return {
               bgCss: {
                  backgroundColor: this.color
				   }
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
